var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2.05007V4.06207C7.054 4.55407 4 7.92007 4 12.0001C4 16.4181 7.582 20.0001 12 20.0001C13.849 20.0001 15.55 19.3731 16.906 18.3201L18.329 19.7431C16.605 21.1531 14.4 22.0001 12 22.0001C6.477 22.0001 2 17.5231 2 12.0001C2 6.81507 5.947 2.55107 11 2.05007ZM21.95 13.0001C21.75 15.0111 20.956 16.8471 19.743 18.3281L18.32 16.9061C19.18 15.7991 19.756 14.4611 19.938 13.0001H21.951H21.95ZM13.002 2.05007C17.726 2.51907 21.482 6.27607 21.952 11.0001H19.939C19.488 7.38207 16.62 4.51407 13.002 4.06207V2.04907V2.05007Z",
    fill: "#484B54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvest);
export default __webpack_public_path__ + "static/media/invest.a7a5a0f9165adb72d665446c2c72e16e.svg";
export { ForwardRef as ReactComponent };